export default "__VITE_ASSET__Qeaot9LX__"